module.exports = __webpack_public_path__ + "static/media/Safe-T12.ab1e108c.jpg";